import { format } from "date-fns";

export const formatMinutes = (parsedTime: Date): string => {
  if (Number(format(parsedTime, "m")) === 0) return "1m";
  return `${format(parsedTime, "m")}m`;
};
